<template>
    <div class="container">
        <div class="header">
            <btn type='pendaftaran' />
            <div class="logo">
                <router-link to="/dashboard">
                <img src="../assets/images/newLogo-old.png" alt="">
                </router-link>
            </div>
        </div>
        <div class="ml-1 text-bold mt-3 mb-1 text-heading">Formulir Pendaftaran Anggota Partai Perindo</div>
        <form @submit.prevent="submitForm">
            <div class="card mb-1">
                <div class="text-bold text-red text-heading mb-1">Kelengkapan Data Diri</div>
                <div class="two-grid formWrapper">
                    <div class="formright">
                        <label for="ktp">NIK KTP</label>
                        <span class="text-red">*</span>
                        <input type="text" name="ktp" placeholder="Masukkan Nomor Identitas KTP" v-model="form.nik"
                            id="nik" required minlength="16" maxlength="16" oninput="this.setCustomValidity('')" @invalid="nikValidation($event)" @keypress="isInputNumber($event)">
                        <label for="nama">Nama Lengkap</label>
                         <span class="text-red">*</span>
                        <input type="text" name="nama" placeholder="Masukkan Nama Lengkap Sesuai KTP"
                            v-model="form.nama_lengkap" required minlength="2" maxlength="50" oninput="this.setCustomValidity('')" oninvalid="this.setCustomValidity('Nama lengkap harus di isi')">
                    </div>
                    <div class="formleft">
                        <div class="two-grid">
                            <div>
                                <label for="tl">Tempat Lahir</label>
                                 <span class="text-red">*</span>
                                <input type="text" name="tl" placeholder="Tempat Lahir Sesuai KTP" oninput="this.setCustomValidity('')" oninvalid="this.setCustomValidity('Tempat lahir harus di isi')"
                                    v-model="form.tempat_lahir" required minlength="2" maxlength="90">
                            </div>
                            <div>
                                <label for="tglL">Tanggal Lahir</label>
                                 <span class="text-red">*</span>
                                <input type="date" name="tglL" v-model="form.tanggal_lahir" required @change="validateBod($event)" oninput="this.setCustomValidity('')" >
                            </div>

                        </div>
                        <div class="label">Jenis Kelamin  <span class="text-red">*</span></div>
                        <div class="flex">
                            <div class="radio">
                                <input type="radio" name="radioBtn" id="pria" value="L" v-model="form.jenis_kelamin"
                                    required>
                                <label for="pria">Laki - laki</label>
                            </div>
                            <div class="radio">
                                <input type="radio" name="radioBtn" id="wanita" value="P" v-model="form.jenis_kelamin">
                                <label for="wanita">Perempuan</label>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="card mb-1">
                <div class="text-bold text-red text-heading mb-1">Informasi Alamat</div>
                <div class="two-grid formWrapper">
                    <div class="formright">
                        <label for="alamat">Alamat Lengkap</label>
                         <span class="text-red">*</span>
                        <input type="text" name="alamat" placeholder="Masukkan Alamat Lengkap Sesuai KTP"
                            v-model="alamat" required minlength="2" maxlength="150" oninput="this.setCustomValidity('')" oninvalid="this.setCustomValidity('Alamat lengkap harus di isi')">
                        <div class="two-grid">
                            <div>
                                <label for="rt">RT</label>
                                 <span class="text-red">*</span>
                                <input type="number" name="rt" placeholder="Masukkan RT" v-model="rt" required maxlength="3" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);">
                            </div>
                            <div>
                                <label for="rw">RW</label>
                                 <span class="text-red">*</span>
                                <input type="number" name="rw" placeholder="Masukkan RW" v-model="rw" required maxlength="3" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);">
                            </div>

                        </div>
                        <label for="provinsi"> Provinsi</label>
                         <span class="text-red">*</span>
                        <select name="provinsi" id="prov" @change="changeList($event)" v-model="form.prov_id" required oninput="this.setCustomValidity('')" oninvalid="this.setCustomValidity('Provinsi harus di isi')">
                            <option value="" disabled selected hidden>Pilih Provinsi Sesuai KTP</option>
                            <option v-for="(p) in provinceList" :key="p.prov_id" :value="p.prov_id"> {{p.prov_name}}
                            </option>

                        </select>
                        <label for="kab">Kabupaten/Kota</label>
                         <span class="text-red">*</span>
                        <select name="kab" id="kabupaten" @change="changeList($event)" v-model="form.kab_id" required oninput="this.setCustomValidity('')" oninvalid="this.setCustomValidity('Kabupaten/Kota harus di isi')">
                            <option value="" disabled selected hidden>Pilih Kabupaten/Kota Sesuai KTP</option>
                            <option v-for="(kab) in kabList" :key="kab.kab_id" :value="kab.kab_id"> {{kab.kab_name}}
                            </option>
                        </select>
                        <label for="kec">Kecamatan</label>
                         <span class="text-red">*</span>
                        <select name="kec" id="kecamatan" @change="changeList($event)" v-model="form.kec_id" required oninput="this.setCustomValidity('')" oninvalid="this.setCustomValidity('Kecamatan harus di isi')">
                            <option value="" disabled selected hidden>Pilih Kecamatan Sesuai KTP</option>
                            <option v-for="(item) in kecList" :key="item.kec_id" :value="item.kec_id"> {{item.kec_name}}
                            </option>
                        </select>
                        <label for="kel">Kelurahan</label>
                         <span class="text-red">*</span>
                        <select name="kel" id="kelurahan" v-model="form.kel_id" required oninput="this.setCustomValidity('')" oninvalid="this.setCustomValidity('kelurahan harus di isi')">
                            <option value="" disabled selected hidden>Pilih Kelurahan Sesuai KTP</option>
                            <option v-for="(item) in kelList" :key="item.kel_id" :value="item.kel_id"> {{item.kel_name}}
                            </option>
                        </select>
                    </div>
                    <div class="formleft">
                        <label for="agama">Agama</label>
                         <span class="text-red">*</span>
                        <select name="agama" id="agama" oninput="this.setCustomValidity('')" oninvalid="this.setCustomValidity('Agama harus di isi')" v-model="form.agama_id" required>
                            <option value="" disabled selected hidden>Pilih Agama Sesuai KTP</option>
                            <option v-for="(item) in agamaList" :key="item.agama_id" :value="item.agama_id">
                                {{item.agama_name}}</option>
                        </select>
                        <label for="Status">Status</label>
                         <span class="text-red">*</span>
                        <select name="Status" id="Status" v-model="form.status_id" required oninput="this.setCustomValidity('')" oninvalid="this.setCustomValidity('Status harus di isi')">
                            <option value="" disabled selected hidden>Pilih Status Sesuai KTP</option>
                            <option v-for="(item) in statusList" :key="item.status_id" :value="item.status_id">
                                {{item.status_name}}</option>
                        </select>
                        <label for="Pekerjaan">Pekerjaan</label>
                         <span class="text-red">*</span>
                        <select name="Pekerjaan" id="Pekerjaan" v-model="form.job_id" required oninput="this.setCustomValidity('')" oninvalid="this.setCustomValidity('Pekerjaan harus di isi')">
                            <option value="" disabled selected hidden>Pilih Pekerjaan Sesuai KTP</option>
                            <option v-for="(item) in jobList" :key="item.job_id" :value="item.job_id"> {{item.job_name}}
                            </option>
                        </select>
                        <label for="Pendidikan">Pendidikan Terakhir</label>
                         <span class="text-red">*</span>
                        <select name="Pendidikan" id="Pendidikan" v-model="form.pendidikan_id" required oninput="this.setCustomValidity('')" oninvalid="this.setCustomValidity('Pendidikan terakhir harus di isi')">
                            <option value="" disabled selected hidden>Pilih Pendidikan Terakhir</option>
                            <option v-for="(item) in listpendidikan" :key="item.pendidikan_id"
                                :value="item.pendidikan_id"> {{item.pendidikan_name}}</option>
                        </select>
                        <label for="tlp">Nomor TLP</label>
                         <!-- <span class="text-red">*</span> -->
                        <input type="number" name="tlp" placeholder="Masukkan Nomor TLP">
                        <label for="email">Email</label>
                         <span class="text-red">*</span>
                        <input type="email" name="email" placeholder="Masukkan Alamat Email" v-model="form.email"
                            required pattern='^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$' @invalid="invalidEmail($event)"  oninput="setCustomValidity('')">
                    </div>
                </div>
            </div>
            <div class="card mb-1">
              <div class="text-bold text-red text-heading mb-1 mt-3">Upload Dokumen</div>
                <div class="two-grid formWrapper">
                  <div class="upload-wrapper">
                    <div class="box-upload">
                      <div class="upload-btn">
                        <input id="fileUpload" type="file" required accept="image/png, image/jpg, image/jpeg, image/webp" @change="uploadedImage($event, 'uploadedImg')">
                        <i class="fas fa-cloud-upload-alt" @click="chooseFiles('fileUpload')"></i></div>
                      <div>
                        <div class="text-blue text-bold">Upload Foto KTP  <span class="text-red">*</span></div>
                        <div class="text-small text-grey">Upload Foto Asli KTP Kamu Pastikan Fotonya Terlihat Jelas</div>
                      </div>
                    </div>
                    <img id="uploadedImg" src="#" alt="ktp-foto" />
                  </div>
                  <div class="upload-wrapper">
                    <div class="box-upload">
                      <div class="upload-btn">
                        <input id="fileUploadProfile" type="file" required accept="image/png, image/jpg, image/jpeg, image/webp" @change="uploadedImage($event, 'uploadedImgProfile')">
                        <i class="fas fa-cloud-upload-alt" @click="chooseFiles('fileUploadProfile')"></i></div>
                      <div>
                        <div class="text-blue text-bold">Foto Diri  <span class="text-red">*</span></div>
                        <div class="text-small text-grey">Upload pass foto 4x6, dipergunakan untuk Foto Kartu Tanda Anggota (KTA)</div>
                      </div>
                    </div>
                    <img id="uploadedImgProfile" src="#" alt="profile-foto" />
                  </div>
              </div>
              <div class="two-grid formWrapper">
              </div>
            </div>
            <div class="card mb-1">
                <h2 class="text-bold text-red text-heading mb-1">Minat Keorganisasian</h2>
                <h3 class="text-bold text-blue">Struktur Organisasi</h3>
                <p class="mb-1">Tertarik untuk terlibat dalam struktur</p>
                <StrukturLevel :options="structures" :value="form.structureId" @input="form.structureId = $event"/>
                <div class="divider" />
                <h3 class="text-bold text-blue">Isu Strategis</h3>
                <p class="mb-1">Tertarik untuk mengerti isu strategis, pilih topik minimal 2 isu strategis</p>
                <IssuesSelector :options="issues" :value="form.selectedIssues" @input="form.selectedIssues = $event" />
            </div>
            <div class="card">
                <div class="text-bold text-red text-heading mb-1">Alamat Domisili </div>
                <div class="flex switch-group mb-2">
                    <div class="text-dim text-bold">Alamat Domisili Sesuai KTP</div>
                    <label class="switch">
                        <input type="checkbox" @change="check($event)" v-model="form.same_address_domisili" >
                        <span class="slider round"></span>
                    </label>
                </div>
                <div v-if="!form.same_address_domisili" class="two-grid formWrapper">
                    <div class="formright">
                        <label for="alamat3">Alamat Lengkap</label>
                         <span class="text-red">*</span>
                        <input type="text" name="alamat3" placeholder="Masukkan Alamat Lengkap Sesuai KTP"
                            v-model="form.alamat_domisili" required minlength="2" maxlength="150">
                        <label for="Negara"> Negara</label>
                         <span class="text-red">*</span>
                        <input type="text" name="Negara" placeholder="Masukkan Negara Sesuai KTP"
                            v-model="form.negara_domisili" required minlength="2" maxlength="20">
                        <!-- <select name="Negara" id="negara">
                            <option value="" disabled selected hidden>Pilih Negara Sesuai KTP</option>
                            <option value="saab">Saab</option>
                            <option value="mercedes">Mercedes</option>
                            <option value="audi">Audi</option>
                        </select> -->
                        <label for="provinsi3"> Provinsi</label>
                         <span class="text-red">*</span>
                        <select name="provinsi3" id="prov" @change="changeList($event, true)" v-model="form.prov_id_domisili" required oninput="this.setCustomValidity('')" oninvalid="this.setCustomValidity('Provinsi harus di isi')">
                            <option value="" disabled selected hidden>Pilih Provinsi Tempat Tinggal</option>
                            <option v-for="(p) in provinceList" :key="p.prov_id" :value="p.prov_id"> {{p.prov_name}}
                            </option>
                        </select>

                        <!-- <label for="alamattt">Alamat</label>
                        <input type="text" name="alamattt" placeholder="Masukkan Alamat Lengkap Tempat Tinggal"> -->
                    </div>
                    <div class="formleft">
                         <label for="kab3">Kabupaten/Kota</label>
                          <span class="text-red">*</span>
                        <select name="kab3" id="kabupaten" @change="changeList($event, true)" v-model="form.kab_id_domisili" required oninput="this.setCustomValidity('')" oninvalid="this.setCustomValidity('Kabupaten harus di isi')">
                            <option value="" disabled selected hidden>Pilih Kabupaten/Kota Tempat Tinggal</option>
                            <option v-for="(kab) in kabListDomisili" :key="kab.kab_id" :value="kab.kab_id"> {{kab.kab_name}}
                            </option>
                        </select>
                        <label for="kec3">Kecamatan</label>
                         <span class="text-red">*</span>
                        <select name="kec3" id="kecamatan" @change="changeList($event, true)" v-model="form.kec_id_domisili" required oninput="this.setCustomValidity('')" oninvalid="this.setCustomValidity('Kecamatan harus di isi')">
                            <option value="" disabled selected hidden>Pilih Kecamatan Tempat Tinggal</option>
                            <option v-for="(item) in kecListDomisili" :key="item.kec_id" :value="item.kec_id"> {{item.kec_name}}
                            </option>
                        </select>
                        <label for="kel3">Kelurahan</label>
                         <span class="text-red">*</span>
                        <select name="kel" id="prov3" v-model="form.kel_id_domisili" required oninput="this.setCustomValidity('')" oninvalid="this.setCustomValidity('Kelurahan harus di isi')">
                            <option value="" disabled selected hidden>Pilih Kelurahan Tempat Tinggal</option>
                            <option v-for="(item) in kelListDomisili" :key="item.kel_id" :value="item.kel_id"> {{item.kel_name}}
                            </option>
                        </select>

                        <!-- <label for="Negara4"> Negara</label>
                        <select name="Negara4" id="negara4">
                            <option value="" disabled selected hidden>Pilih Negara Tempat Tinggal</option>
                        </select>
                        <label for="wilayah4"> Wilayah</label>
                        <select name="wilayah4" id="wilayah4">
                            <option value="" disabled selected hidden>Pilih Wilayah Tempat Tinggal</option>
                        </select>
                        <label for="Kota4"> Kota</label>
                        <select name="Kota4" id="Kota4">
                            <option value="" disabled selected hidden>Pilih Tempat Tinggal</option>
                        </select>
                        <label for="alamat4">Alamat</label>
                        <input type="text" name="alamat4" placeholder="Masukkan AlamatTempat Tinggal"> -->

                    </div>
                </div>
                <button class="btn-fill blue text-bold">Selesai</button>
            </div>
        </form>
    </div>
    <loader v-if="isLoad" />
    <modal-referensi
      :show="showRefModal"
      :options="referensiOption"
      @close="showRefModal = false"
      @save="handleSaveReferensi"
    />
  <success-submit
    :show="showSuccessModal"
    :imageSrc="require('../assets/images/reg-done.png')"
  />
</template>

<script>
import btn from '../components/backBtn.vue'
import encoded from '../mixins/encodeForm'
import loader from '../components/loader.vue'
import ModalReferensi from '../components/ReferensiPendaftaranModal.vue'
import StrukturLevel from '../components/StrukturLevel.vue'
import IssuesSelector from '../components/IssuesSelector.vue'
import SuccessSubmit from '../components/SuccessSubmit.vue'
import getAddress from '../mixins/getAddress'
import axios from 'axios'
export default {
  components: {
    btn,
    loader,
    ModalReferensi,
    SuccessSubmit,
    StrukturLevel,
    IssuesSelector
  },
  mixins: [encoded, getAddress],
  data () {
    return {
      isLoad: false,
      showRefModal: false,
      showSuccessModal: false,
      sesuaiKTP: false,
      provinceList: null,
      selectedIssues: [],
      structures: null,
      issues: null,
      referensiOption: null,
      kabList: null,
      kecList: null,
      kelList: null,
      kabListDomisili: null,
      kecListDomisili: null,
      kelListDomisili: null,
      agamaList: null,
      listpendidikan: null,
      jobList: null,
      rt: '',
      rw: '',
      statusList: null,
      alamat: '',
      form: {
        nik: '',
        nama_lengkap: '',
        tempat_lahir: '',
        tanggal_lahir: null,
        jenis_kelamin: '',
        agama_id: '',
        status_id: '',
        pendidikan_id: '',
        job_id: '',
        alamat_ktp: '',
        email: '',
        prov_id: '',
        kab_id: '',
        kec_id: '',
        kel_id: '',
        same_address_domisili: false,
        prov_id_domisili: '',
        kab_id_domisili: '',
        kec_id_domisili: '',
        kel_id_domisili: '',
        alamat_domisili: '',
        negara_domisili: '',
        foto_ktp: null,
        foto_profile: null,
        referensi_pendaftaran: '',
        referensi_pendaftaran_lainnya: '',
        structureId: '',
        selectedIssues: []
      }
    }
  },
  watch: {
    'form.nik': {
      handler (nik) {
        const fixlength = 16
        if (nik.length > fixlength) {
          nik = nik.slice(0, fixlength)
        }
      }
    },
  },
  methods: {
    nikValidation (e) {
      if (!this.form.nik) e.target.setCustomValidity('Nik harus di isi')
      else e.target.setCustomValidity('Nik harus terdiri dari 16 karater')
    },
    isInputNumber (evt) {
      var ch = String.fromCharCode(evt.which)

      if (!(/[0-9]/.test(ch))) {
        evt.preventDefault()
      }
    },
    check (e) {
      if (e.target.checked) {
        this.form.same_address_domisili = true
      } else {
        this.form.same_address_domisili = false
      }
    },
    chooseFiles (id) {
      document.getElementById(id).click()
    },
    // async selectProv() {
    //     try {
    //         const provList = await axios.get(`member/listprovinsi`)
    //         this.provinceList = provList.data
    //         this.logger(provList)
    //     } catch (err) {
    //         this.logger(err)
    //     }
    // },
    async changeList (e, domisili = false) {
      const id = e.target.value
      if (e.srcElement.id === 'prov') {
        this.getKabupaten(id, domisili)
      } else if (e.srcElement.id === 'kabupaten') {
        this.getKecamatan(id, domisili)
      } else if (e.srcElement.id === 'kecamatan') {
        this.getKelurahan(id, domisili)
      }
    },
    async getMasterStructure() {
      try {
        const list = await axios.get('structure/category-master')
        this.structures = list?.data?.data
      } catch (error) {
        this.logger(error)
      }
    },
    async getMasterIssues() {
      try {
        const issues = await axios.get('member/issues-master')
        this.issues = issues?.data
      } catch (error) {
        this.logger(error)
      }
    },
    async getReferensiOptions() {
      try {
        const list = await axios.get('member/reference-master')
        this.referensiOption = list?.data
      } catch (error) {
        this.logger(error)
      }
    },
    async getKabupaten (i, domisili = false) {
      try {
        const kabList = await axios.get(`member/listkabupatenkota?prov_id=${i}`)
        if (!domisili) this.kabList = kabList.data
        if (domisili) this.kabListDomisili = kabList.data
      } catch (err) {
        this.logger(err)
      }
    },
    async getKecamatan (i, domisili = false) {
      try {
        const kecList = await axios.get(`member/listkecamatan?kab_id=${i}`)
        if (!domisili) this.kecList = kecList.data
        if (domisili) this.kecListDomisili = kecList.data
      } catch (err) {
        this.logger(err)
      }
    },
    async getKelurahan (i, domisili = false) {
      this.logger('get kelurahan')
      try {
        const kelList = await axios.get(`member/listkelurahandesa?kec_id=${i}`)
        if (!domisili) this.kelList = kelList.data
        if (domisili) this.kelListDomisili = kelList.data
      } catch (err) {
        this.logger(err)
      }
    },
    async getAgama () {
      try {
        const agamaList = await axios.get('member/listagama')
        this.agamaList = agamaList.data
      } catch (err) {
        this.logger(err)
      }
    },
    async getPendidikan () {
      try {
        const listpendidikan = await axios.get('member/listpendidikan')
        this.listpendidikan = listpendidikan.data
      } catch (err) {
        this.logger(err)
      }
    },
    async getJobList () {
      try {
        const jobList = await axios.get('member/listjob')
        this.jobList = jobList.data
      } catch (err) {
        this.logger(err)
      }
    },
    async listStatus () {
      try {
        const statusList = await axios.get('member/liststatus')
        this.statusList = statusList.data
      } catch (err) {
        this.logger(err)
      }
    },
    submitForm () {
      this.showRefModal = true
    },
    async daftarMember () {
      //  var nik = document.getElementById('nik').value;
      //     var nikRGEX = /^[Z0-9]{16,16}$/;
      //     var nikResult = nikRGEX.test(nik);
      //     if(nikResult == false){
      //          alert("nik harus 16 digit");
      // return
      //     }
      if (this.form.foto_ktp.size > 1000000) {
        this.alertFailed('file size harus di bawah 1MB')
        return
      }

      this.form.alamat_ktp = `${this.alamat} RT. ${this.rt} RW. ${this.rw}`
      const data = new FormData()
      data.append('nik', this.form.nik)
      data.append('nama_lengkap', this.form.nama_lengkap)
      data.append('tempat_lahir', this.form.tempat_lahir)
      data.append('tanggal_lahir', this.form.tanggal_lahir)
      data.append('jenis_kelamin', this.form.jenis_kelamin)
      data.append('agama_id', this.form.agama_id)
      data.append('status_id', this.form.status_id)
      data.append('pendidikan_id', this.form.pendidikan_id)
      data.append('job_id', this.form.job_id)
      data.append('alamat_ktp', this.form.alamat_ktp)
      data.append('email', this.form.email)
      data.append('prov_id', this.form.prov_id)
      data.append('kab_id', this.form.kab_id)
      data.append('kec_id', this.form.kec_id)
      data.append('kel_id', this.form.kel_id)
      data.append('same_address_domisili', this.form.same_address_domisili)
      data.append('prov_id_domisili', this.form.prov_id_domisili)
      data.append('kab_id_domisili', this.form.kab_id_domisili)
      data.append('kec_id_domisili', this.form.kec_id_domisili)
      data.append('kel_id_domisili', this.form.kel_id_domisili)
      data.append('alamat_domisili', this.form.alamat_domisili)
      data.append('negara_domisili', this.form.negara_domisili)
      data.append('foto_ktp', this.form.foto_ktp)
      data.append('foto_profile', this.form.foto_profile)
      data.append('country_code', 'ID')
      data.append('reference_id', String(this.form.referensi_pendaftaran))
      data.append('reference_other', this.form.referensi_pendaftaran_lainnya)
      this.form.selectedIssues?.forEach(el => {
        data.append('issues_id', el)
      })
      data.append('category_id', this.form.structureId)

      // // data.append('nik',this.form.nik)
      // this.logger(data, 'dataa')
      // this.data.append('coba', 'haha')
      // this.logger(this.data, 'dass')

      try {
        this.isLoad = true
        const regMember = await axios.post('member/register', data)
        if (regMember.status === 201) {
          this.isLoad = false
          //this.alertNormal('Sukses Mendaftar Sebagai Member')
          //this.$router.push('/dashboard')
          this.showSuccessModal = true
          setTimeout(() => {
            this.showSuccessModal = false
            this.$router.push('/dashboard')
          }, 1000)
        }
        this.logger(regMember)
      } catch (err) {
        this.isLoad = false
        // this.logger(err.response)
        if (err.response) {
          this.alertFailed(err.response.data)
        }
      }
    },
    uploadedImage (e, id) {
      const type = e.target.files[0].type

      if (!type.match('image/png') && !type.match('image/jpg') && !type.match('image/jpeg') && !type.match('image/webp')) {
        this.alertFailed('Tipe file tidak diterima.')
        return
      }

      const [file] = e.target.files
      if (id === 'uploadedImg') {
        this.form.foto_ktp = file
      } else if (id === 'uploadedImgProfile') {
        this.form.foto_profile = file
      }
      // this.logger(file.size)
      if (file) {
        // var binaryData = [];
        // binaryData.push(file);
        const blah = document.getElementById(id)
        blah.src = window.URL.createObjectURL(file)
        blah.classList.add('active')
      }
    },
    validateBod (e) {
      const birthData = new Date(this.form.tanggal_lahir)
      var diffMs = Date.now() - birthData.getTime()
      var ageDt = new Date(diffMs)
      const diff = Math.abs(ageDt.getUTCFullYear() - 1970)
      if (!this.form.tanggal_lahir) {
        e.target.setCustomValidity('Tanggal lahir wajib diisi')
        return
      }
      if (diff < 17) {
        e.target.setCustomValidity('Umur harus di atas 17 tahun')
      }
    },
    invalidEmail (e) {
      e.target.setCustomValidity('Format email tidak valid')
    },
    async handleSaveReferensi (payload) {
      this.form.referensi_pendaftaran = payload.id
      this.form.referensi_pendaftaran_lainnya = payload.lainnya_text

      await this.daftarMember()
    }
  },
  async mounted () {
    this.isLoad = true
    try {
      await this.$store.dispatch('getProfile')
    } catch (err) {
      this.logger('profile not found')
    }

    if (this.$store.state.profile) {
      this.alertFailed('Anda sudah terdaftar sebagai Member')
      // this.isLoad = false
      this.$router.push('/dashboard')
    }
    this.isLoad = false
    this.selectProv()
    this.getAgama()
    this.getPendidikan()
    this.getJobList()
    this.listStatus()
    this.getMasterIssues()
    this.getMasterStructure()
    this.getReferensiOptions()
  }
}
</script>

<style lang="scss" scoped>
    .header {
        display: flex;
        justify-content: space-between;
        margin-top: 2rem;
        align-items: center;

        @media only screen and (max-width: 600px) {
            display: block;
        }

        .logo {
            width: 80px;

            @media only screen and (max-width: 600px) {
                margin-top: 1rem;
            }
        }
    }

    .card {
        padding: 20px;

        @media only screen and (max-width: 600px) {
            width: 100%;
        }

        .two-grid.formWrapper {
            grid-gap: 5rem;

            @media only screen and (max-width: 600px) {
                grid-template-columns: 1fr;
            }
        }

        .radio {
            margin-right: 2rem;

            label {
                font-weight: normal;
                color: grey;
                line-height: unset;
            }

            input {
                // margin: 0;
                margin-right: 5px;
                width: auto;
            }

            [type="radio"]:checked,
            [type="radio"]:not(:checked) {
                position: absolute;
                opacity: 0;
                // left: -9999px;
            }

            [type="radio"]:checked+label,
            [type="radio"]:not(:checked)+label {
                position: relative;
                padding-left: 28px;
                cursor: pointer;
                line-height: 20px;
                display: inline-block;
                color: #666;
            }

            [type="radio"]:checked+label:before,
            [type="radio"]:not(:checked)+label:before {
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                width: 18px;
                height: 18px;
                border: 1px solid $blue;
                border-radius: 100%;
                background: #fff;
            }

            [type="radio"]:checked+label:after,
            [type="radio"]:not(:checked)+label:after {
                content: '';
                width: 14px;
                height: 14px;
                background: $blue;
                position: absolute;
                top: 3px;
                left: 3px;
                border-radius: 100%;
                -webkit-transition: all 0.2s ease;
                transition: all 0.2s ease;
            }

            [type="radio"]:not(:checked)+label:after {
                opacity: 0;
                -webkit-transform: scale(0);
                transform: scale(0);
            }

            [type="radio"]:checked+label:after {
                opacity: 1;
                -webkit-transform: scale(1);
                transform: scale(1);
            }
        }

        .upload-wrapper {
          @media screen and (max-width: 600px) {
            width: 370x;
          }
        }

        .box-upload {
            padding: 20px;
            border: 1px solid #ccc;
            display: grid;
            grid-template-columns: 1fr 2fr;
            grid-gap: 2rem;
            width: 100%;

            .upload-btn {
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;

                i {
                    font-size: 50px;
                    color: black;
                }
            }
        }

        .btn-fill {
            width: 300px;
            padding: 10px;
            border-radius: 10px;
            margin: 3rem auto 1rem auto;
        }
    }

    label,
    .label {
        color: $blue;
        font-weight: bold;
        line-height: 2;
    }

    input,
    select {
        border-color: #d1d1d1;
        border-width: 1px;
        border-radius: 5px;
        margin-bottom: 1rem;
        padding: 10px 1rem;
    }

    select {
        width: 100%;
        color: grey;
    }

    .switch {
        position: relative;
        display: inline-block;
        width: 52px;
        height: 23px;
    }

    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: $blue;
        -webkit-transition: .4s;
        transition: .4s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 28px;
        width: 28px;
        left: -2px;
        bottom: -2px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
        box-shadow: 0 0.3px 1.9px 0 rgba(33, 64, 154, 0.16), 0 0.8px 4.3px 0 rgba(33, 64, 154, 0.12), 0 1.5px 7.7px 0 rgba(33, 64, 154, 0.1), 0 2.4px 12.8px 0 rgba(33, 64, 154, 0.09), 0 4px 21.2px 0 rgba(33, 64, 154, 0.07), 0 6.9px 37px 0 rgba(33, 64, 154, 0.06), 0 15px 80px 0 rgba(33, 64, 154, 0.04);
    }

    input:checked+.slider {
        background-color: #2196F3;
    }

    input:focus+.slider {
        box-shadow: 0 0 1px #2196F3;
    }

    input:checked+.slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: 34px;
    }

    .slider.round:before {
        border-radius: 50%;
    }

    .switch-group {
        .text-bold {
            width: 400px;
        }
    }

    input[type="file"] {
        opacity: 0;
    }

    span{
        margin-left: 5px;
    }

    #uploadedImg{
      margin: 1rem auto;
      opacity: 0;
      visibility: hidden;
      max-width: 500px;
      &.active{
          opacity: 1;
          visibility: visible;
      }
      @media screen and (max-width: 600px) {
        max-width: 250px;
      }
    }
    #uploadedImgProfile{
        opacity: 0;
        visibility: hidden;
        max-width: 500px;
        margin: 1rem auto;
        &.active{
            opacity: 1;
            visibility: visible;
        }
        @media screen and (max-width: 600px) {
          max-width: 250px;
        }
    }

.divider {
  margin-top: 12px;
  margin-bottom: 12px;
  height: 1px;
  background-color: #C0C0C0;
  width: 100%
}
</style>
